// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3q5Cr","content":"LoadingAlert_content__1hiy3"};